const faqs = [
    {
        id: 1,
        heading: 'Czy praktyki są płatne?',
        content: 'Obecnie nie — są wolontariackie, ale dają realne doświadczenie i kwalifikacje.',
    },
    {
        id: 2,
        heading: 'Czy można łączyć praktyki ze szkołą lub studiami?',
        content: 'Tak, grafik dopasowujemy indywidualnie.',
    },
    {
        id: 3,
        heading: 'Czy praktyki są zdalne?',
        content: 'Wiele zadań tak — część może wymagać obecności na miejscu.',
    },
    {
        id: 4,
        heading: 'Czy potrzebuję doświadczenia?',
        content: 'Nie, wszystkiego Cię nauczymy.',
    },
];

export default faqs;